// extracted by mini-css-extract-plugin
export default {"wrapper":"Moc_wrapper__dmbfP","content":"Moc_content__ecSdT","title":"Moc_title__c23qg","buttons":"Moc_buttons__0svVh"};